import React from 'react'
import styles from './modalWithBackground.jcss'
import { grid } from 'theme'
import { cn } from 'ethcss'
import Icon from 'blocks.simple/icon/icon'

interface IModalWithBackgroundProps {
    isOpen: boolean
    onClose: () => void
    title?: string
    children?: React.ReactNode
    showCloseIcon?: boolean
}

const ModalWithBackground: React.FC<IModalWithBackgroundProps> = ({ isOpen, onClose, title, children, showCloseIcon = false }) => {
    if (!isOpen) return null

    return (
        <div className={styles.wrapper} onClick={onClose}>
            <div className={styles.inner} onClick={(e) => e.stopPropagation()}>
                <div className={cn(grid.row, grid.justify)}>
                    {title && <div className={styles.title}>{title}</div>}
                    {showCloseIcon && <Icon type="close" size={14} onClick={onClose}/>}
                </div>
                <div className={styles.content}>{children}</div>
            </div>
        </div>
    )
}

export default ModalWithBackground